import { motion } from "framer-motion";
import { Check, X } from "@phosphor-icons/react";
import { useI18n } from "@/i18n";

export const ComparisonTable = () => {
  const { t } = useI18n();
  const ROWS = t("cmp.rows");
  return (
    <section className="border-t border-white/10 bg-lc-slate/10" data-testid="comparison-table">
      <div className="max-w-6xl mx-auto px-6 py-20">
        <motion.div initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="text-center">
          <span className="font-mono text-[11px] uppercase tracking-[0.28em] text-lc-sky">{t("cmp.overline")}</span>
          <h2 className="mt-3 font-serif text-3xl sm:text-4xl tracking-tight max-w-3xl mx-auto [text-wrap:balance]">
            {t("cmp.title")}
          </h2>
        </motion.div>

        <div className="mt-12 overflow-hidden rounded-sm border border-white/10">
          {/* header */}
          <div className="grid grid-cols-3 bg-lc-navy">
            <div className="px-4 sm:px-6 py-4 font-mono text-[10px] sm:text-[11px] uppercase tracking-wider text-lc-fog">{t("cmp.hDim")}</div>
            <div className="px-4 sm:px-6 py-4 font-mono text-[10px] sm:text-[11px] uppercase tracking-wider text-lc-fog">{t("cmp.hManual")}</div>
            <div className="px-4 sm:px-6 py-4 font-mono text-[10px] sm:text-[11px] uppercase tracking-wider text-lc-sky border-l border-lc-sky/30 bg-lc-sky/5">{t("cmp.hShield")}</div>
          </div>
          {ROWS.map((r, i) => (
            <motion.div key={i} initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ delay: i * 0.05 }}
              data-testid={`comparison-row-${i}`}
              className={`grid grid-cols-3 border-t border-white/10 ${i % 2 ? "bg-lc-slate/20" : "bg-lc-navy/40"}`}>
              <div className="px-4 sm:px-6 py-5 text-xs sm:text-sm font-semibold text-white">{r.dim}</div>
              <div className="px-4 sm:px-6 py-5 flex items-start gap-2 text-xs sm:text-sm text-lc-fog">
                <X weight="bold" size={15} className="mt-0.5 shrink-0 text-lc-critical/70" />
                <span>{r.manual}</span>
              </div>
              <div className="px-4 sm:px-6 py-5 flex items-start gap-2 text-xs sm:text-sm text-white border-l border-lc-sky/30 bg-lc-sky/5">
                <Check weight="bold" size={15} className="mt-0.5 shrink-0 text-lc-ok" />
                <span className="font-semibold">{r.shield}</span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ComparisonTable;
